import React from 'react';

import { Box } from '@mui/material';

import { DeleteIconButton, ExternalLinkIconButton } from '@components/buttons';

import type { ActionButtonsProperties } from './ActionButtons.types';

export const ActionButtons: React.FC<ActionButtonsProperties> = ({
  url = '',
  onDelete,
  dataTest = 'action_buttons',
}) => (
  <Box
    data-testid={dataTest}
    sx={{
      display: 'flex',
      gap: 0.5,
      ml: 1,
      flexShrink: 0
    }}>
    <ExternalLinkIconButton href={url} dataTest={`${dataTest}_open`} />
    <DeleteIconButton onClick={onDelete} dataTest={`${dataTest}_delete`} />
  </Box>
);
